![Contrato de Promesa Editor](https://assets.elevenestudio.me/changelog-idc/promise-contract-editor.png)

## Editor para Contratos de Promesa

El contrato de promesa ahora puede editarse directamente desde un editor enriquecido en lugar de ser generado únicamente por código. Esto permite personalizar el contenido del documento antes de generar el PDF final.

## 🚀 Nuevas funcionalidades

### Editor de bloques 📝
- **Bloque de Comparecencia** - Inserta la sección de comparecencia según el tipo de cliente
- **Bloque de Fe Notarial** - Agrega la fe notarial al documento
- Integración con el menú de comandos del editor (slash menu)


## 🔧 Mejoras

- Actualización del motor de renderizado PDF para soportar los nuevos bloques editables
- Mejora en la estructura de datos para manejar información compleja de clientes

## 🐛 Correcciones

- Nombre de alcance corregido en tabla de activos inmobiliarios
